import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import LabelAndTextArea from '../common/form/labelAndTextarea';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import FormatUtils from '../common/formatUtils/FormatUtils';
import pdfAdd from '../assets/images/icone_add_pdf.png';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';
import { setError } from '../common/toast/toast';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import SelectDefault from '../common/form/selectDefault';
import DateFormat from '../common/dateFormat/DateFormat';
import ColorUtils from '../common/colorUtils/ColorUtils';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import ButtonTable from '../common/table/buttonTable';
import consts from '../consts';
import ListaAutoSuggestManual from '../common/form/ListaAutoSuggestManual';
import InputAssinatura from '../common/form/inputAssinatura';

import {
	setModoTelaChecklist as setModoTela, initFormChecklist as initForm, voltarControlePatio
} from './controlePatioActions';

class ControlePatioChecklistForm extends Component {

	state = {

	}

	render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='cavalo'
								options={this.props.listaCavalo}
								component={Select}
								label='Cavalo'
								cols='12 1 1 1'
								minWidth={170}
								placeholder='Selecione'
								readOnly={'readOnly'} />

							<Field
								name='carreta1'
								options={this.props.listaCarreta}
								component={Select}
								label='Carreta1'
								cols='12 1 1 1'
								minWidth={170}
								placeholder='Selecione'
								readOnly={'readOnly'} />

							<Field
								name='carreta2'
								options={this.props.listaCarreta}
								component={Select}
								label='Carreta 2'
								cols='12 1 1 1'
								minWidth={170}
								placeholder='Selecione'
								readOnly={'readOnly'} />
								
							<Field
								name='id_motorista'
								options={this.props.listaMotorista}
								component={Select}
								label='Motorista'
								cols='12 1 1 1'
								minWidth={350}
								placeholder='Selecione'
								readOnly={'readOnly'} />
						</Row>
						
						{this.checklist()}

						{/*<Row alignCenter>
							<Grid cols='12 12 8 8'>
								<p style={{ marginTop: 42, fontSize: 16 }}>
									Sr. Motorista, neste momento da saída do pátio da matriz, o caminhão retorna à sua responsabilidade integral, cabendo ao motorista a condução segura do veículo, bem como a conferência das condições gerais para início da viagem. Sendo assim, o motorista declara estar ciente das condições do veículo e apto a prosseguir com o transporte, assumindo a responsabilidade a partir deste momento até o destino final.
								</p>
							</Grid>
							<Grid cols='12 12 12 12'>
								<Row alignCenter style={{ marginTop: 24 }}>
									<InputAssinatura
										idUploadAssinatura={`inputAssinatura_motorista`}
										label={`Assinatura do Motorista`}
										value={this.props.formularioValues.assinatura_motorista_saida}
										semGaleria
										onChange={(assinatura) => {
											this.props.initForm({
												...this.props.formularioValues,
												assinatura_motorista_saida: assinatura,
												termo_concordancia_saida: 'Sr. Motorista, neste momento da saída do pátio da matriz, o caminhão retorna à sua responsabilidade integral, cabendo ao motorista a condução segura do veículo, bem como a conferência das condições gerais para início da viagem. Sendo assim, o motorista declara estar ciente das condições do veículo e apto a prosseguir com o transporte, assumindo a responsabilidade a partir deste momento até o destino final.',
												datahora_assinatura_motorista_saida: DateFormat.getDataHoraAtual()
											});
										}} />
								</Row>
							</Grid>
							<Grid cols='12 12 12 12' style={{ textAlign: 'center' }}>
								<label>{this.props.formularioValues.nome_motorista}</label>
							</Grid>
						</Row>*/}

					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								<Button
									text='Finalizar Checklist'
									submit
									type={'success'}
									icon={'fa fa-check'}
									disabled={!this.validarChecklist()} />
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => {
										if (this.props.formularioValues.idOrigemControlePatio) {
											this.props.voltarControlePatio(this.props.formularioValues.idOrigemControlePatio);
										} else {
											this.props.setModoTela('lista');
										}
									}} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		);
	}

	checklist() {

		return (
			<Row>
				<Grid cols='12 12 12 12'>
					<table style={{ width: '100%' }}>
						<thead>
							<tr style={{ height: 60 }}>
								<th width={10}>Checklist</th>
								<th width={10}></th>
								<th width={10}></th>
								<th width={1000}>Observação</th>
							</tr>
						</thead>
						<tbody>
							{(this.props.formularioValues ? this.props.formularioValues.listaChecklist : []).map((pergunta, i) => {
								return (
									<tr key={pergunta.id}
										style={{
											backgroundColor: this.validarChecklist(pergunta.id_pergunta) ? (i%2 == 0 ? '#1F3066' : '#2b3d7aff') : '#d94141'
										}}>
										<td style={{ minWidth: 180, paddingLeft: 12, verticalAlign: 'middle', color: '#ffffff', fontWeight: 'bold' }}>{pergunta.nome_pergunta}</td> 
										<td style={{ verticalAlign: 'middle' }}>
											<LabelAndInput
												label={null}
												cols='12 12 12 12'
												minWidth={160}
												value={pergunta.resposta}
												readOnly={pergunta.editavel ? null : 'readOnly'}
												onChange={data => {
													this.props.initForm({
														...this.props.formularioValues,
														listaChecklist: this.props.formularioValues.listaChecklist.map(perguntaAux => {
															if (perguntaAux.id_pergunta == pergunta.id_pergunta) {
																return {
																	...perguntaAux,
																	resposta: data.target.value
																};
															} else {
																return {
																	...perguntaAux
																};
															}
														})
													});
												}} />
										</td>
										<td style={{ verticalAlign: 'middle' }}>
											<div class='btn-group btn-group-toggle' style={{ marginTop: 4 }}>
												<label class={`btn ${pergunta.id_resposta == 1 ? 'bg-success active' : 'bg-light'}`}>
													<input type='radio' name='options1' id='option_b1' autocomplete='off' checked=''
														onChange={() => {
															this.props.initForm({
																...this.props.formularioValues,
																listaChecklist: this.props.formularioValues.listaChecklist.map(perguntaAux => {
																	if (perguntaAux.id_pergunta == pergunta.id_pergunta) {
																		return {
																			...perguntaAux,
																			id_resposta: 1
																		};
																	} else {
																		return {
																			...perguntaAux
																		};
																	}
																})
															});
														}} /> Sim
												</label>
												<label class={`btn ${pergunta.id_resposta == 2 ? 'bg-olive active' : 'bg-light'}`}>
													<input type='radio' name='options2' id='option_b2' autocomplete='off'
														onChange={() => {
															this.props.initForm({
																...this.props.formularioValues,
																listaChecklist: this.props.formularioValues.listaChecklist.map(perguntaAux => {
																	if (perguntaAux.id_pergunta == pergunta.id_pergunta) {
																		return {
																			...perguntaAux,
																			id_resposta: 2
																		};
																	} else {
																		return {
																			...perguntaAux
																		};
																	}
																})
															});
														}} /> Indif.
												</label>
												<label class={`btn ${pergunta.id_resposta == 3 ? 'bg-danger active' : 'bg-light'}`}>
													<input type='radio' name='options3' id='option_b3' autocomplete='off'
														onChange={() => {															
															this.props.initForm({
																...this.props.formularioValues,
																listaChecklist: this.props.formularioValues.listaChecklist.map(perguntaAux => {
																	if (perguntaAux.id_pergunta == pergunta.id_pergunta) {
																		return {
																			...perguntaAux,
																			id_resposta: 3
																		};
																	} else {
																		return {
																			...perguntaAux
																		};
																	}
																})
															});
														}} /> Não
												</label>
											</div>
										</td>
										<td style={{ verticalAlign: 'middle' }}>
											<LabelAndInput
												label={null}
												cols='12 12 12 12'
												value={pergunta.observacao}
												onChange={data => {
													this.props.initForm({
														...this.props.formularioValues,
														listaChecklist: this.props.formularioValues.listaChecklist.map(perguntaAux => {
															if (perguntaAux.id_pergunta == pergunta.id_pergunta) {
																return {
																	...perguntaAux,
																	observacao: data.target.value
																};
															} else {
																return {
																	...perguntaAux
																};
															}
														})
													});
												}} />
										</td>
									</tr>
								)
							})}
						</tbody>
					</table>
				</Grid>					
			</Row>
		)
	}

	validarChecklist(idPergunta) {
		//Se respondeu algum como não precida de observação
		return !(this.props.formularioValues ? this.props.formularioValues.listaChecklist : []).filter(pergunta => !idPergunta || pergunta.id_pergunta == idPergunta).filter((pergunta, i) => {
			return (pergunta.id_resposta == 3 && (pergunta.observacao || '').trim().length < 4);
		}).length;
	}
}

ControlePatioChecklistForm = reduxForm({ form: 'controlePatioFormChecklist', destroyOnUnmount: false })(ControlePatioChecklistForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	formularioValues: getFormValues('controlePatioFormChecklist')(state),
	listaMotorista: state.controlePatio.listaMotorista,
	listaCavalo: state.controlePatio.listaCavalo,
	listaCarreta: state.controlePatio.listaCarreta
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, voltarControlePatio
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ControlePatioChecklistForm);